<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <material-card
      :title="$t('components.themesettings.image_settings')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="image"
    >
      <v-container v-if="loaded">
        <div
          v-for="trans of themeSettings.ImageSettings.ImageSettingsTranslations"
          v-bind:key="trans.LanguageCode"
        >
          <div class="row">
            <h5 style="margin-left:5px">{{ trans.LanguageName }}</h5>
          </div>
          <div class="row">
            <div class="col-md-4 col-xs-12">
              <div class="title">
                {{ $t("components.themesettings.banner") }}
              </div>
              <image-picker :image.sync="trans.Banner"></image-picker>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="title">{{ $t("globals.logo") }}</div>
              <image-picker :image.sync="trans.Logo"></image-picker>
            </div>
            <div class="col-md-4 col-xs-12">
              <div class="title">
                {{ $t("components.themesettings.pagetitleicon") }}
              </div>
              <image-picker :image.sync="trans.PageTitleIcon"></image-picker>
            </div>
          </div>
        </div>
      </v-container>
    </material-card>
    <material-card
      :title="$t('components.themesettings.font_settings')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="font_download"
    >
      <v-container v-if="loaded">
        <v-form v-model="fontsValid">
          <v-row>
            <v-col md="4" sm="12">
              <no-autocomplete-textfield
                v-model="themeSettings.FontFamily"
                :label="$t('components.themesettings.fontFamily')"
                :rules="[$rules.required]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col md="4" sm="12">
              <no-autocomplete-textfield
                v-model="themeSettings.FontSizeHeader1"
                :label="$t('components.themesettings.fontSizeHeader1')"
                :rules="[$rules.required]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col md="4" sm="12">
              <no-autocomplete-textfield
                v-model="themeSettings.FontSizeHeader2"
                :label="$t('components.themesettings.fontSizeHeader2')"
                :rules="[$rules.required]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="4" sm="12">
              <no-autocomplete-textfield
                v-model="themeSettings.FontSizeHeader3"
                :label="$t('components.themesettings.fontSizeHeader3')"
                :rules="[$rules.required]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col md="4" sm="12">
              <no-autocomplete-textfield
                v-model="themeSettings.FontSizeHeader4"
                :label="$t('components.themesettings.fontSizeHeader4')"
                :rules="[$rules.required]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col md="4" sm="12">
              <no-autocomplete-textfield
                v-model="themeSettings.FontSizeHeader5"
                :label="$t('components.themesettings.fontSizeHeader5')"
                :rules="[$rules.required]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="4" sm="12">
              <no-autocomplete-textfield
                v-model="themeSettings.FontSizeHeader6"
                :label="$t('components.themesettings.fontSizeHeader6')"
                :rules="[$rules.required]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col md="4" sm="12">
              <no-autocomplete-textfield
                v-model="themeSettings.FontSizeNormal"
                :label="$t('components.themesettings.fontSizeNormal')"
                :rules="[$rules.required]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col md="4" sm="12">
              <no-autocomplete-textfield
                v-model="themeSettings.FontSizeLink"
                :label="$t('components.themesettings.fontSizeLink')"
                :rules="[$rules.required]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="4" sm="12">
              <no-autocomplete-textfield
                v-model="themeSettings.FontSizeFooterNormal"
                :label="$t('components.themesettings.fontSizeFooterNormal')"
                :rules="[$rules.required]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col md="4" sm="12">
              <no-autocomplete-textfield
                v-model="themeSettings.FontSizeFooterLink"
                :label="$t('components.themesettings.fontSizeFooterLink')"
                :rules="[$rules.required]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </material-card>
    <material-card
      :title="$t('components.themesettings.color_settings')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="palette"
    >
      <v-container v-if="loaded">
        <v-row>
          <v-col md="6" sm="12">
            <div class="title">
              {{ $t("components.themesettings.body_font_color") }}
            </div>
            <v-color-picker
              v-model="themeSettings.BodyFontColor"
              :rules="[$rules.required]"
              class="required"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="6" sm="12">
            <div class="title">
              {{ $t("components.themesettings.body_background_color") }}
            </div>
            <v-color-picker
              v-model="themeSettings.BodyBackgroundColor"
              :rules="[$rules.required]"
              class="required"
              mode="hexa"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div
              :style="{
                margin: '0 auto',
                padding: '30px',
                'background-color': themeSettings.BodyBackgroundColor,
                'text-align': 'center',
                color: themeSettings.BodyFontColor,
              }"
            >
              {{$t("components.themesettings.body_font")}}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4" sm="12">
            <div class="title">
              {{ $t("components.themesettings.link_color") }}
            </div>
            <v-color-picker
              v-model="themeSettings.LinkColor"
              :rules="[$rules.required]"
              class="required"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="4" sm="12">
            <div class="title">{{ $t("components.themesettings.visited_link_color") }}</div>
            <v-color-picker
              v-model="themeSettings.VisitedLinkColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="4" sm="12">
            <div class="title">{{ $t("components.themesettings.hover_link_color") }}</div>
            <v-color-picker
              v-model="themeSettings.HoverLinkColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.BodyBackgroundColor,
                'text-align': 'center',
                color: themeSettings.LinkColor,
              }"
            >
              {{$t("components.themesettings.link")}}
            </div>
          </v-col>
          <v-col md="4" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.BodyBackgroundColor,
                'text-align': 'center',
                color: themeSettings.VisitedLinkColor,
              }"
            >
              {{$t("components.themesettings.visited_link")}}
            </div>
          </v-col>
          <v-col md="4" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.BodyBackgroundColor,
                'text-align': 'center',
                color: themeSettings.HoverLinkColor,
              }"
            >
              {{$t("components.themesettings.hover_link")}}
            </div>
          </v-col>
        </v-row>
         <v-row>
          <v-col md="6" sm="12">
            <div class="title">
              {{ $t("components.themesettings.top_banner_border_color") }}
            </div>
            <v-color-picker
              v-model="themeSettings.TopBannerBorderColor"
              :rules="[$rules.required]"
              class="required"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="6" sm="12">
            <div class="title">
              {{ $t("headers.left_drawer_menu_items.page_title_color") }}
            </div>
            <v-color-picker
              v-model="themeSettings.PageTitleColor"
              :rules="[$rules.required]"
              class="required"
              mode="hexa"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '30px',
                'background-color': themeSettings.BodyBackgroundColor,
                'text-align': 'center',
                color: themeSettings.TopBannerBorderColor,
              }"
            >
              {{$t("components.themesettings.top_banner_border")}}
            </div>
          </v-col>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '30px',
                'background-color': themeSettings.BodyBackgroundColor,
                'text-align': 'center',
                color: themeSettings.PageTitleColor,
              }"
            >
              {{$t("components.themesettings.page_title")}}
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.left_menu_link_background_color_1") }}</div>
            <v-color-picker
              v-model="themeSettings.LeftMenuLinkBackgroundColor1"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.left_menu_link_font_color_1") }}</div>
            <v-color-picker
              v-model="themeSettings.LeftMenuLinkFontColor1"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.left_menu_link_background_color_2") }}</div>
            <v-color-picker
              v-model="themeSettings.LeftMenuLinkBackgroundColor2"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.left_menu_link_font_color_2") }}</div>
            <v-color-picker
              v-model="themeSettings.LeftMenuLinkFontColor2"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.LeftMenuLinkBackgroundColor1,
                'text-align': 'center',
                color: themeSettings.LeftMenuLinkFontColor1,
              }"
            >
              {{$t("components.themesettings.left_menu_link_1")}}
            </div>
          </v-col>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.LeftMenuLinkBackgroundColor2,
                'text-align': 'center',
                color: themeSettings.LeftMenuLinkFontColor2,
              }"
            >
              {{$t("components.themesettings.left_menu_link_2")}}
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.right_menu_link_background_color_1") }}</div>
            <v-color-picker
              v-model="themeSettings.RightMenuLinkBackgroundColor1"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.right_menu_link_font_color_1") }}</div>
            <v-color-picker
              v-model="themeSettings.RightMenuLinkFontColor1"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.right_menu_link_background_color_2") }}</div>
            <v-color-picker
              v-model="themeSettings.RightMenuLinkBackgroundColor2"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.right_menu_link_font_color_2") }}</div>
            <v-color-picker
              v-model="themeSettings.RightMenuLinkFontColor2"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.RightMenuLinkBackgroundColor1,
                'text-align': 'center',
                color: themeSettings.RightMenuLinkFontColor1,
              }"
            >
              {{$t("components.themesettings.right_menu_link_1")}}
            </div>
          </v-col>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.RightMenuLinkBackgroundColor2,
                'text-align': 'center',
                color: themeSettings.RightMenuLinkFontColor2,
              }"
            >
              {{$t("components.themesettings.right_menu_link_2")}}
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.left_menu_selected_link_background_color") }}</div>
            <v-color-picker
              v-model="themeSettings.LeftMenuSelectedLinkBackgroundColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.left_menu_selected_link_font_color") }}</div>
            <v-color-picker
              v-model="themeSettings.LeftMenuSelectedLinkFontColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.left_menu_hover_link_background_color") }}</div>
            <v-color-picker
              v-model="themeSettings.LeftMenuHoverLinkBackgroundColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.left_menu_hover_link_font_color") }}</div>
            <v-color-picker
              v-model="themeSettings.LeftMenuHoverLinkFontColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.LeftMenuSelectedLinkBackgroundColor,
                'text-align': 'center',
                color: themeSettings.LeftMenuSelectedLinkFontColor,
              }"
            >
              {{$t("components.themesettings.selected_left_menu_link")}}
            </div>
          </v-col>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.LeftMenuHoverLinkBackgroundColor,
                'text-align': 'center',
                color: themeSettings.LeftMenuHoverLinkFontColor,
              }"
            >
              {{$t("components.themesettings.hover_left_menu_link")}}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.right_menu_selected_link_background_color") }}</div>
            <v-color-picker
              v-model="themeSettings.RightMenuSelectedLinkBackgroundColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.right_menu_selected_link_font_color") }}</div>
            <v-color-picker
              v-model="themeSettings.RightMenuSelectedLinkFontColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.right_menu_hover_link_background_color") }}</div>
            <v-color-picker
              v-model="themeSettings.RightMenuHoverLinkBackgroundColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.right_menu_hover_link_font_color") }}</div>
            <v-color-picker
              v-model="themeSettings.RightMenuHoverLinkFontColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.RightMenuSelectedLinkBackgroundColor,
                'text-align': 'center',
                color: themeSettings.RightMenuSelectedLinkFontColor,
              }"
            >
              {{$t("components.themesettings.selected_right_menu_link")}}
            </div>
          </v-col>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.RightMenuHoverLinkBackgroundColor,
                'text-align': 'center',
                color: themeSettings.RightMenuHoverLinkFontColor,
              }"
            >
              {{$t("components.themesettings.hover_right_menu_link")}}
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="4" sm="12">
            <div class="title">{{ $t("components.themesettings.input_focus_color") }}</div>
            <v-color-picker
              v-model="themeSettings.InputFocusColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="4" sm="12">
            <div class="title">
              {{ $t("components.themesettings.footer_font_color") }}
            </div>
            <v-color-picker
              v-model="themeSettings.FooterFontColor"
              :rules="[$rules.required]"
              class="required"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="4" sm="12">
            <div class="title">
              {{ $t("components.themesettings.footer_background_color") }}
            </div>
            <v-color-picker
              v-model="themeSettings.FooterBackgroundColor"
              :rules="[$rules.required]"
              class="required"
              mode="hexa"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div
              :style="{
                margin: '0 auto',
                padding: '30px',
                'background-color': themeSettings.FooterBackgroundColor,
                'text-align': 'center',
                color: themeSettings.FooterFontColor,
              }"
            >
              {{$t("components.themesettings.footer_font")}}
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="4" sm="12">
            <div class="title">
              {{ $t("components.themesettings.footer_link_color") }}
            </div>
            <v-color-picker
              v-model="themeSettings.FooterLinkColor"
              :rules="[$rules.required]"
              class="required"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="4" sm="12">
            <div class="title">{{ $t("components.themesettings.footer_visited_link_color") }}</div>
            <v-color-picker
              v-model="themeSettings.FooterVisitedLinkColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="4" sm="12">
            <div class="title">{{ $t("components.themesettings.footer_hover_link_color") }}</div>
            <v-color-picker
              v-model="themeSettings.FooterHoverLinkColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.FooterBackgroundColor,
                'text-align': 'center',
                color: themeSettings.FooterLinkColor,
              }"
            >
              {{$t("components.themesettings.footer_link")}}
            </div>
          </v-col>
          <v-col md="4" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.FooterBackgroundColor,
                'text-align': 'center',
                color: themeSettings.FooterVisitedLinkColor,
              }"
            >
              {{$t("components.themesettings.footer_visited_link")}}
            </div>
          </v-col>
          <v-col md="4" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.FooterBackgroundColor,
                'text-align': 'center',
                color: themeSettings.FooterHoverLinkColor,
              }"
            >
              {{$t("components.themesettings.footer_hover_link")}}
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="6" sm="12">
            <div class="title">{{ $t("components.themesettings.footer_menu_link_background_color") }}</div>
            <v-color-picker
              v-model="themeSettings.FooterMenuBackgroundColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="6" sm="12">
            <div class="title">{{ $t("components.themesettings.footer_menu_link_font_color") }}</div>
            <v-color-picker
              v-model="themeSettings.FooterMenuFontColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="12" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.FooterMenuBackgroundColor,
                'text-align': 'center',
                color: themeSettings.FooterMenuFontColor,
              }"
            >
              {{$t("components.themesettings.footer_menu_link")}}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.footer_menu_selected_link_background_color") }}</div>
            <v-color-picker
              v-model="themeSettings.FooterMenuSelectedBackgroundColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.footer_menu_selected_link_font_color") }}</div>
            <v-color-picker
              v-model="themeSettings.FooterMenuSelectedFontColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.footer_menu_hover_link_background_color") }}</div>
            <v-color-picker
              v-model="themeSettings.FooterMenuHoverBackgroundColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.footer_menu_hover_link_font_color") }}</div>
            <v-color-picker
              v-model="themeSettings.FooterMenuHoverFontColor"
              :rules="[$rules.required]"
              mode="hexa"
              class="required"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.FooterMenuSelectedBackgroundColor,
                'text-align': 'center',
                color: themeSettings.FooterMenuSelectedFontColor,
              }"
            >
              {{$t("components.themesettings.selected_footer_menu_link")}}
            </div>
          </v-col>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.FooterMenuHoverBackgroundColor,
                'text-align': 'center',
                color: themeSettings.FooterMenuHoverFontColor,
              }"
            >
              {{$t("components.themesettings.hover_footer_menu_link")}}
            </div>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col md="4" sm="12">
            <div class="title">
              {{ $t("components.themesettings.benefit_card_header_font_color") }}
            </div>
            <v-color-picker
              v-model="themeSettings.BenefitCardHeaderFontColor"
              :rules="[$rules.required]"
              class="required"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="4" sm="12">
            <div class="title">{{ $t("components.themesettings.horizontal_tab_header_background_color") }}</div>
            <v-color-picker
              v-model="themeSettings.HorizontalTabHeaderBackgroundColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="4" sm="12">
            <div class="title">{{ $t("components.themesettings.horizontal_tab_header_font_color") }}</div>
            <v-color-picker
              v-model="themeSettings.HorizontalTabHeaderFontColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.BodyBackgroundColor,
                'text-align': 'center',
                color: themeSettings.BenefitCardHeaderFontColor,
              }"
            >
              {{$t("components.themesettings.benefit_card_header")}}
            </div>
          </v-col>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.HorizontalTabHeaderBackgroundColor,
                'text-align': 'center',
                color: themeSettings.HorizontalTabHeaderFontColor,
              }"
            >
              {{$t("components.themesettings.horizontal_tab_header")}}
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.horizontal_tab_header_background_hover_color") }}</div>
            <v-color-picker
              v-model="themeSettings.HorizontalTabHeaderBackgroundHoverColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.horizontal_tab_header_font_hover_color") }}</div>
            <v-color-picker
              v-model="themeSettings.HorizontalTabHeaderFontHoverColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.horizontal_tab_header_background_select_color") }}</div>
            <v-color-picker
              v-model="themeSettings.HorizontalTabHeaderBackgroundSelectedColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.horizontal_tab_header_font_select_color") }}</div>
            <v-color-picker
              v-model="themeSettings.HorizontalTabHeaderFontSelectedColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.HorizontalTabHeaderBackgroundHoverColor,
                'text-align': 'center',
                color: themeSettings.HorizontalTabHeaderFontHoverColor,
              }"
            >
              {{$t("components.themesettings.horizontal_tab_header_hover")}}
            </div>
          </v-col>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.HorizontalTabHeaderBackgroundSelectedColor,
                'text-align': 'center',
                color: themeSettings.HorizontalTabHeaderFontSelectedColor,
              }"
            >
              {{$t("components.themesettings.horizontal_tab_select_header")}}
            </div>
          </v-col>
        </v-row>


        <v-row>
          <v-col md="6" sm="12">
            <div class="title">{{ $t("components.themesettings.dc_file_tile_background_color") }}</div>
            <v-color-picker
              v-model="themeSettings.DownloadCenterFileTabBackgroundColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="6" sm="12">
            <div class="title">{{ $t("components.themesettings.dc_file_tile_font_color") }}</div>
            <v-color-picker
              v-model="themeSettings.DownloadCenterFileTabFontColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="12" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.DownloadCenterFileTabBackgroundColor,
                'text-align': 'center',
                color: themeSettings.DownloadCenterFileTabFontColor,
              }"
            >
              {{$t("components.themesettings.dc_file_tile")}}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.dc_file_tile_background_hover_color") }}</div>
            <v-color-picker
              v-model="themeSettings.DownloadCenterFileTabBackgroundHoverColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.dc_file_tile_font_hover_color") }}</div>
            <v-color-picker
              v-model="themeSettings.DownloadCenterFileTabFontHoverColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.dc_file_tile_background_selected_color") }}</div>
            <v-color-picker
              v-model="themeSettings.DownloadCenterFileTabBackgroundSelectedColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
          <v-col md="3" sm="12">
            <div class="title">{{ $t("components.themesettings.dc_file_tile_font_selected_color") }}</div>
            <v-color-picker
              v-model="themeSettings.DownloadCenterFileTabFontSelectedColor"
              :rules="[$rules.required]"
              mode="hexa"
            ></v-color-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.DownloadCenterFileTabBackgroundHoverColor,
                'text-align': 'center',
                color: themeSettings.DownloadCenterFileTabFontHoverColor,
              }"
            >
              {{$t("components.themesettings.dc_file_tile_hover")}}
            </div>
          </v-col>
          <v-col md="6" sm="12">
            <div
              :style="{
                margin: '0 auto',
                padding: '10px',
                'background-color': themeSettings.DownloadCenterFileTabBackgroundSelectedColor,
                'text-align': 'center',
                color: themeSettings.DownloadCenterFileTabFontSelectedColor,
              }"
            >
              {{$t("components.themesettings.dc_file_tile_selected")}}
            </div>
          </v-col>
        </v-row>

      </v-container>
    </material-card>
    <v-card-actions>
      <v-btn :loading="saving" :disabled="!valid()" color="primary" @click="save">{{
        $t("globals.save")
      }}</v-btn>
    </v-card-actions>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">{{
        $t("globals.close")
      }}</v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import ImagePicker from "../components/ImagePicker";
import { mapActions, mapGetters } from "vuex";
import store from "@/store";
import ErrorHandler from "../components/ErrorHandler";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import { portalPermission } from "../mixins/portalPermission";
export default {
  name: "theme-settings",
  components: {
    ImagePicker,
    ErrorHandler,
    NoAutocompleteTextfield
  },
  mixins: [planSetter, portalPermission],
  data: () => ({
    saving: false,
    fontsValid: false,
    snackbar: false,
    color: "",
    mode: "",
    timeout: 2500,
    message: "",
    error: null,
    themeSettings: {
      BodyFontColor: "#000000FF",
      BodyBackgroundColor: "#FFFFFFFF",
      LinkColor: "#239FC9FF",
      VisitedLinkColor: "#114D61FF",
      HoverLinkColor: "#85ADBBFF",
      TopBannerBorderColor: "#09857EFF",
      PageTitleColor: "#09857EFF",
      LeftMenuLinkBackgroundColor1: "#12DAA7FF",
      LeftMenuLinkBackgroundColor2: "#11BD91FF",
      LeftMenuLinkFontColor1: "#FFFFFFFF",
      LeftMenuLinkFontColor2: "#FFFFFFFF",
      RightMenuLinkBackgroundColor1: "#DA8812FF",
      RightMenuLinkBackgroundColor2: "#FF9F15FF",
      RightMenuLinkFontColor1: "#FFFFFFFF",
      RightMenuLinkFontColor2: "#FFFFFFFF",
      FooterBackgroundColor: "#000000FF",
      FooterFontColor: "#FFFFFFFF",
      FooterLinkColor: "#FFFFFFFF",
      FooterVisitedLinkColor: "#A8A8A8FF",
      FooterHoverLinkColor: "#DBD8D8FF",
      FontSizeHeader1: "32px",
      FontSizeHeader2: "30px",
      FontSizeHeader3: "24px",
      FontSizeHeader4: "20px",
      FontSizeHeader5: "18px",
      FontSizeHeader6: "16px",
      FontFamily: '"Barlow", sans-serif',
      FontSizeNormal: "16px",
      FontSizeLink: "16px",
      FontSizeFooterNormal: "16px",
      FontSizeFooterLink: "16px",
      LeftMenuSelectedLinkBackgroundColor: "#696969",
      LeftMenuSelectedLinkFontColor: "#FFFFFFFF",
      LeftMenuHoverLinkBackgroundColor: "#696969",
      LeftMenuHoverLinkFontColor: "#FFFFFFFF",
      RightMenuSelectedLinkBackgroundColor: "#696969",
      RightMenuSelectedLinkFontColor: "#FFFFFFFF",
      RightMenuHoverLinkBackgroundColor: "#696969",
      RightMenuHoverLinkFontColor: "#FFFFFFFF",
      InputFocusColor:"#DA8812FF",
      BenefitCardHeaderFontColor: "#000000FF",
      HorizontalTabHeaderBackgroundColor: "#12DAA7FF",
      HorizontalTabHeaderFontColor: "#FFFFFFFF",
      HorizontalTabHeaderBackgroundHoverColor: "#12DAA7FF",
      HorizontalTabHeaderFontHoverColor: "#FFFFFFFF",
      HorizontalTabHeaderBackgroundSelectedColor: "#12DAA7FF",
      HorizontalTabHeaderFontSelectedColor: "#FFFFFFFF",
      DownloadCenterFileTabBackgroundColor: "#ABB3B3FF",
      DownloadCenterFileTabFontColor: "#FFFFFFFF",
      DownloadCenterFileTabBackgroundHoverColor: "#ABB3B3FF",
      DownloadCenterFileTabFontHoverColor: "#FFFFFFFF",
      DownloadCenterFileTabBackgroundSelectedColor: "#666666FF",
      DownloadCenterFileTabFontSelectedColor: "#FFFFFFFF",
      FooterMenuBackgroundColor: "#000000FF",
      FooterMenuFontColor: "#FFFFFFFF",
      FooterMenuSelectedBackgroundColor: "#696969",
      FooterMenuSelectedFontColor: "#FFFFFFFF",
      FooterMenuHoverBackgroundColor: "#696969",
      FooterMenuHoverFontColor: "#FFFFFFFF",
    },
    loaded: false,
  }),
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("downloadCenter", ["getThemeSettings", "saveThemeSettings"]),
    valid() {
      let valid = this.fontsValid;
      if (this.themeSettings===null || this.themeSettings === undefined) return false;
      if (this.themeSettings.ImageSettings===null || this.themeSettings.ImageSettings === undefined) return false;
      for (const trans of this.themeSettings.ImageSettings
        .ImageSettingsTranslations) {
        valid =
          trans.Banner !== null &&
          trans.Banner !== undefined &&
          trans.Logo !== null &&
          trans.Logo !== undefined;
        if (!valid) break;
      }
      return valid;
    },
    async loadPlanData() {
      const languages = store.getters["common/languages"];
      try {
        const themeSettings = await this.getThemeSettings(this.selectedPlan.Id);
        if (themeSettings) {
          //console.log(languages);
          for (var k in themeSettings) {
            this.themeSettings[k] = themeSettings[k]
              ? themeSettings[k]
              : this.themeSettings[k];
          }
          for (var l of languages) {
            if (
              !this.themeSettings.ImageSettings.ImageSettingsTranslations.some(
                (t) => t.LanguageCode == l.language
              )
            ) {
              this.themeSettings.ImageSettings.ImageSettingsTranslations.push({
                LanguageCode: l.language,
                LanguageName: l.title,
              });
            } else {
              this.themeSettings.ImageSettings.ImageSettingsTranslations.filter(
                (t) => t.LanguageCode == l.language
              )[0].LanguageName = l.title;
            }
          }
          this.loaded = true;
          //console.log("theme");
          //console.log(this.themeSettings);
        }
        this.themeSettings.PlanId = this.selectedPlan.Id;
      } catch (error) {
        this.error = error;
      }
    },
    async save() {
      this.saving = true;
      delete this.themeSettings["@odata.context"];
      if (this.themeSettings.Id === "00000000-0000-0000-0000-000000000000") {
        delete this.themeSettings.Id;
        delete this.themeSettings.ImageSettingsId;
        delete this.themeSettings.ImageSettings.Id;
      }
      for (let img of this.themeSettings.ImageSettings
        .ImageSettingsTranslations) {
        img.BannerId = img.Banner.Id;
        delete img.Banner;
        img.LogoId = img.Logo.Id;
        delete img.Logo;
        if (img.PageTitleIcon) {
          img.PageTitleIconId = img.PageTitleIcon.Id;
          delete img.PageTitleIcon;
        }
      }
      try {
        await this.saveThemeSettings(this.themeSettings);
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.load();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
  },
};
</script>

<style scoped>
.title {
  padding: 5px 0;
  font-size: 1rem !important;
}
</style>
